import React from "react";
import { Button, Input } from "@mui/material";

const PlayerSetup = ({ formData, setFormData }) => {
    const handlePlayerChange = (index, value) => {
        const newPlayers = [...formData.players];
        newPlayers[index] = value;
        setFormData((prev) => ({ ...prev, players: newPlayers }));
    };

    const addPlayer = () => {
        setFormData((prev) => ({ ...prev, players: [...prev.players, ""] }));
    };

    const removePlayer = (index) => {
        setFormData((prev) => ({ ...prev, players: prev.players.filter((_, i) => i !== index) }));
    };

    return (
        <div className="form-container">
            <h2>Add Players</h2>
            <div style={{display: "flex", flexDirection: "column", gap: "10px"}}>
                {formData.players.map((player, index) => (
                    <div key={index} className="player-entry">
                        <Input
                            label={`Player ${index + 1}`}
                            value={player}
                            onChange={(e) => handlePlayerChange(index, e.target.value)}
                            fullWidth
                            margin="normal"
                            endDecorator={<Button onClick={() => removePlayer(index)}><i className={'fi-rr-trash'}></i></Button>}
                        />
                    </div>
                ))}
            </div>
            <Button onClick={addPlayer} variant={'contained'}>Add Player</Button>
        </div>
    );
};

export default PlayerSetup;